import { Card } from "@/components/ui/card";

const RecordCardSkeleton = () => {
  return (
    <Card className="overflow-hidden border border-border/50">
      <div className="relative">
        <div className="p-4 sm:p-5">
          {/* Десктопная версия */}
          <div className="hidden sm:flex items-start justify-between gap-4">
            <div className="flex items-start gap-4">
              {/* Иконка файла */}
              <div className="flex-shrink-0 h-16 w-12 bg-muted rounded-xl animate-pulse"></div>
              
              {/* Информация о записи */}
              <div className="flex-1 min-w-0">
                <div className="h-5 bg-muted rounded animate-pulse w-3/4 mb-2"></div>
                <div className="h-4 bg-muted rounded animate-pulse w-1/2"></div>
              </div>
            </div>
            
            {/* Статус и дата */}
            <div className="flex flex-col items-end gap-2">
              <div className="h-6 bg-muted rounded-full animate-pulse w-20"></div>
              <div className="h-3 bg-muted rounded animate-pulse w-24"></div>
            </div>
          </div>

          {/* Мобильная версия */}
          <div className="sm:hidden">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3 flex-1 min-w-0">
                {/* Иконка файла */}
                <div className="flex-shrink-0 h-14 w-11 bg-muted rounded-xl animate-pulse"></div>
                
                {/* Информация о записи */}
                <div className="flex-1 min-w-0 pt-0.5">
                  <div className="h-4 bg-muted rounded animate-pulse w-3/4 mb-2"></div>
                  <div className="h-3 bg-muted rounded animate-pulse w-1/2"></div>
                </div>
              </div>

              {/* Статус и дата */}
              <div className="flex-shrink-0 pt-0.5 flex flex-col items-end gap-2">
                <div className="h-5 bg-muted rounded-full animate-pulse w-16"></div>
                <div className="h-3 bg-muted rounded animate-pulse w-20"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default RecordCardSkeleton;